module.exports = __webpack_public_path__ + "img/image_019.e40536de.jpeg";